(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["b2b-quick-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('b2b-quick-order')) {
    class B2BQuickOrder extends HTMLElement {
      connectedCallback() {
        const $ = (s) => this.querySelector(`[${s}]`);
        this.els = {
          select: $('ref-select'), price: $('ref-price'), rrp: $('ref-rrp'), rrpWrap: $('ref-rrp-wrap'),
          breaks: $('ref-breaks'), stock: $('ref-stock'), qty: $('ref-qty'), minus: $('ref-minus'),
          plus: $('ref-plus'), add: $('ref-add'), rule: $('ref-rule'), error: $('ref-error'),
          offers: Array.from(this.querySelectorAll('[ref-offer]')),
        };
        // Evita que los clics abran la ficha de producto (la tarjeta es un enlace)
        ['click', 'pointerdown', 'keydown'].forEach((ev) =>
          this.addEventListener(ev, (e) => e.stopPropagation())
        );
        this.els.select.addEventListener('change', () => this.update(true));
        this.els.minus.addEventListener('click', () => this.step(-1));
        this.els.plus.addEventListener('click', () => this.step(1));
        this.els.qty.addEventListener('change', () => { this.clamp(); this.renderBreaks(); });
        this.els.add.addEventListener('click', (e) => { e.preventDefault(); this.addToOrder(); });
        this.els.offers.forEach((btn) =>
          btn.addEventListener('click', (e) => { e.preventDefault(); this.addOffer(btn); })
        );
        this.update(true);
      }

      get opt() { return this.els.select.selectedOptions[0]; }
      get rule() {
        const d = this.opt.dataset;
        return { min: +d.min || 1, max: d.max ? +d.max : Infinity, step: +d.step || 1 };
      }

      clamp() {
        const { min, max, step } = this.rule;
        let q = parseInt(this.els.qty.value, 10) || min;
        q = Math.max(min, Math.min(max, q));
        const off = (q - min) % step;
        if (off) q = q - off + (off >= step / 2 ? step : 0);
        if (q > max) q -= step;
        q = Math.max(min, q);
        // Biodiscan: en oferta, una cantidad escrita a mano se sube al siguiente múltiplo válido (7, 14…).
        const blocks = this.offerBlocks;
        if (blocks) {
          const snapped = window.BDOffer.snapUp(q, blocks);
          if (snapped !== q) window.BDOffer.toast(`Esta oferta va en ${window.BDOffer.describe(blocks)} unidades: hemos ajustado la cantidad.`);
          q = Math.min(max, snapped);
        }
        this.els.qty.value = q;
      }

      // Biodiscan: bloques de la oferta de este producto ("7", "6,10") o null.
      get offerBlocks() {
        return this.dataset.offerBlocks && window.BDOffer ? this.dataset.offerBlocks : null;
      }

      step(dir) {
        const blocks = this.offerBlocks;
        const current = parseInt(this.els.qty.value, 10) || 0;
        if (blocks) {
          // Biodiscan: +/− saltan entre cantidades válidas de la oferta (… 6, 7, 14, 21…).
          const target = dir > 0 ? window.BDOffer.next(current, blocks) : window.BDOffer.prev(current, blocks);
          this.els.qty.value = Math.max(this.rule.min, Math.min(this.rule.max, target));
        } else {
          this.els.qty.value = current + dir * this.rule.step;
          this.clamp();
        }
        this.renderBreaks();
      }

      update(resetQty) {
        const d = this.opt.dataset;
        const { min, max, step } = this.rule;
        this.els.price.textContent = d.price;
        if (this.els.rrpWrap) {
          this.els.rrpWrap.hidden = !d.rrp;
          this.els.rrp.textContent = d.rrp;
        }
        if (this.els.stock) {
          this.els.stock.textContent = d.statusText;
          this.els.stock.dataset.status = d.status;
        }
        const q = this.els.qty;
        q.min = min; q.step = step;
        if (max !== Infinity) q.max = max; else q.removeAttribute('max');
        if (resetQty) q.value = min;
        this.clamp();

        const parts = [];
        if (min > 1) parts.push(`Mín. ${min}`);
        if (step > 1) parts.push(`en múltiplos de ${step}`);
        if (max !== Infinity) parts.push(`máx. ${max}`);
        this.els.rule.textContent = parts.join(' · ');

        const add = this.els.add;
        const out = d.status === 'out';
        add.disabled = out;
        q.disabled = out;
        this.els.offers.forEach((btn) => { btn.disabled = out; });
        add.textContent = out ? add.dataset.textUnavailable
          : d.status === 'preorder' ? add.dataset.textPreorder : add.dataset.textAdd;
        this.els.error.hidden = true;
        this.renderBreaks();
      }

      renderBreaks() {
        let breaks = [];
        try { breaks = JSON.parse(this.opt.dataset.breaks || '[]'); } catch (e) {}
        if (!breaks.length) { this.els.breaks.hidden = true; return; }
        const qty = parseInt(this.els.qty.value, 10) || 0;
        const sorted = breaks.slice().sort((a, b) => b.q - a.q);
        const hit = sorted.find((b) => qty >= b.q);
        this.els.price.textContent = hit ? hit.p : this.opt.dataset.price;
        this.els.breaks.hidden = false;
        this.els.breaks.textContent = breaks
          .sort((a, b) => a.q - b.q)
          .map((b) => `${b.q}+ uds: ${b.p}`)
          .join(' · ');
      }

      // Misma animación "vuela al carrito" que usa el tema en su botón de añadir
      flyToCart(sourceButton) {
        const icon = document.querySelector('.header-actions__cart-icon');
        const image = this.opt?.dataset.image || this.dataset.image;
        if (!icon || !image || !customElements.get('fly-to-cart')) return;
        const el = document.createElement('fly-to-cart');
        el.classList.add('fly-to-cart--main');
        el.style.setProperty('background-image', `url(${image})`);
        el.style.setProperty('--start-opacity', '0');
        el.source = sourceButton || this.els.add;
        el.destination = icon;
        document.body.appendChild(el);
      }

      addToOrder() {
        this.clamp();
        const variantId = Number(this.els.select.value);
        const quantity = Number(this.els.qty.value);
        return this.addItems([{ id: variantId, quantity }], this.els.add);
      }

      // Añade las unidades justas para activar la oferta (p. ej. 4+1 = 5 uds).
      // La unidad de regalo va en una línea aparte para que el descuento
      // se aplique a una línea entera (evita errores con pago a plazo).
      addOffer(btn) {
        const variantId = Number(this.els.select.value);
        const buy = Number(btn.dataset.buy) || 0;
        const get = Number(btn.dataset.get) || 0;
        const items = [];
        if (get > 0 && this.dataset.splitGift === 'true') {
          items.push({ id: variantId, quantity: buy });
          items.push({ id: variantId, quantity: get, properties: { _oferta: btn.dataset.label } });
        } else {
          items.push({ id: variantId, quantity: buy + get });
        }
        return this.addItems(items, btn);
      }

      async addItems(items, add) {
        const label = add.innerHTML;
        const variantId = items[0].id;
        const quantity = items.reduce((sum, i) => sum + i.quantity, 0);
        const routes = (window.Theme && window.Theme.routes) || {};
        const addUrl = routes.cart_add_url || '/cart/add.js';
        const cartUrl = `${routes.cart_url || '/cart'}.js`;

        add.disabled = true;
        add.setAttribute('aria-busy', 'true');
        this.els.error.hidden = true;

        // Eventos estándar del tema: actualizan el icono y el cajón del carrito
        let CartLinesUpdateEvent = null;
        try {
          ({ CartLinesUpdateEvent } = await import('@shopify/events'));
        } catch (e) {}

        let deferred = null;
        let settled = false;
        if (CartLinesUpdateEvent) {
          deferred = CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
              promise: deferred.promise,
            })
          );
        }

        this.flyToCart(add);

        // Secciones del carrito que el tema tiene en la página (cajón / página de carrito)
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);

        const resolveWith = (cart, extra) => {
          if (!deferred || settled) return;
          settled = true;
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'b2b-quick-order',
              sourceId: this.id,
              itemCount: quantity,
              productId: this.dataset.productId,
              ...extra,
            },
          });
        };

        try {
          const res = await fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items,
              sections: sectionIds.join(','),
            }),
          });
          const data = await res.json();
          const cart = await (await fetch(cartUrl, { headers: { Accept: 'application/json' } })).json();

          if (!res.ok || data.status) {
            resolveWith(cart, { didError: true });
            throw new Error(data.description || data.message || 'Error');
          }

          resolveWith(cart, { sections: data.sections, didError: false });

          add.textContent = add.dataset.textAdded;
          setTimeout(() => { add.innerHTML = label; add.disabled = false; }, 1800);
        } catch (err) {
          if (deferred && !settled) {
            settled = true;
            deferred.reject(err);
          }
          this.els.error.textContent = err.message;
          this.els.error.hidden = false;
          add.innerHTML = label;
          add.disabled = false;
        } finally {
          add.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('b2b-quick-order', B2BQuickOrder);
  }
  } catch(e) { console.error(e); }
})();

})();
